export default {
  lang: {
    selectAll: '모든 페이지 선택',
    selected: '선정',
    term: '기사',
    deselect: '당선자',
  },
};
